__turbopack_context__.v({
  "cornerstoneNavigation": "r8tb3W_cornerstoneNavigation",
});
